import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import AIPiggyBank from '../components/AIPiggyBank';

export default function AuthActionPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const mode = searchParams.get('mode');
  const oobCode = searchParams.get('oobCode');

  useEffect(() => {
    if (!mode || !oobCode) {
      return;
    }

    switch (mode) {
      case 'verifyEmail':
        navigate(`/verify-email?oobCode=${oobCode}`, { replace: true });
        break;
      case 'resetPassword':
        navigate(`/reset-password?oobCode=${oobCode}`, { replace: true });
        break;
      case 'recoverEmail':
        navigate(`/verify-email?oobCode=${oobCode}&mode=recoverEmail`, { replace: true });
        break;
      default:
        break;
    }
  }, [mode, oobCode, navigate]);

  const showError = !mode || !oobCode || !['verifyEmail', 'resetPassword', 'recoverEmail'].includes(mode);

  if (!showError) {
    return (
      <div
        className="min-h-screen flex items-center justify-center relative overflow-hidden"
        style={{ background: 'linear-gradient(135deg, #120938 0%, #241A4C 100%)' }}
      >
        <div className="bg-bg-primary p-8 rounded-2xl shadow-xl w-full max-w-md relative z-10 text-center">
          <div className="flex justify-center">
            <svg className="animate-spin h-12 w-12 text-brand-teal" viewBox="0 0 24 24">
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
                fill="none"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
          </div>
          <p className="text-text-secondary mt-4">Redirecting...</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="min-h-screen flex items-center justify-center relative overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #120938 0%, #241A4C 100%)' }}
    >
      <AIPiggyBank className="absolute bottom-0 right-0 w-96 h-96 opacity-25 pointer-events-none select-none transform translate-x-16 translate-y-16" />

      <div className="bg-bg-primary p-8 rounded-2xl shadow-xl w-full max-w-md relative z-10 text-center">
        <div className="w-16 h-16 bg-system-error/20 rounded-full mx-auto flex items-center justify-center mb-4">
          <svg className="w-8 h-8 text-system-error" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-text-primary">Invalid Link</h1>
        <p className="text-text-secondary mt-2">
          {!oobCode
            ? 'This link is missing required information.'
            : !mode
              ? 'This link is missing the action type.'
              : 'This link contains an unrecognized action type.'}
        </p>
        <div className="pt-4">
          <p className="text-sm text-text-tertiary">
            Please check the link or request a new one from the app.
          </p>
        </div>
      </div>
    </div>
  );
}
